import Configuration from '@/views/Configuration/Configuration.vue'

const routes = {
  path: '/configuration',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/configuration',
      name: 'Configuration',
      component: Configuration,
      meta: {
        title: 'Perfil',
      },
    },
  ],
}

export default routes
